/** Cycle 15.4 — skeleton loaders: never a blank screen or spinner-only page.
 * Shimmer respects prefers-reduced-motion via the global animation kill-switch. */

export const Skel = ({ w = "100%", h = 13, r = 7, style }) => (
  <span className="skel" style={{ width: w, height: h, borderRadius: r, ...style }} aria-hidden="true" />
);

/** Generic card list — staff boards, settings panes, ledgers. */
export const SkelList = ({ n = 3, lines = 2, testId = "skeleton-loader" }) => (
  <div data-testid={testId} role="status" aria-label="Loading">
    {Array.from({ length: n }).map((_, i) => (
      <div className="skel-card" key={i}>
        <Skel w={`${52 + ((i * 17) % 30)}%`} h={15} />
        {Array.from({ length: lines }).map((_, j) => (
          <Skel key={j} w={`${86 - j * 14 - ((i * 11) % 10)}%`} h={11} />
        ))}
      </div>
    ))}
  </div>
);

/** Dish-tile shaped — customer menu. */
export const SkelDishes = ({ n = 5, testId = "skeleton-menu" }) => (
  <div data-testid={testId} role="status" aria-label="Loading the menu">
    {Array.from({ length: n }).map((_, i) => (
      <div className="skel-dish" key={i}>
        <Skel w={64} h={64} r={13} style={{ flex: "0 0 auto" }} />
        <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 8 }}>
          <Skel w={`${48 + ((i * 13) % 26)}%`} h={14} />
          <Skel w="82%" h={10} />
          <Skel w={54} h={12} />
        </div>
      </div>
    ))}
  </div>
);

/** Ticket-board shaped — KDS / station boards. */
export const SkelBoard = ({ n = 3, testId = "skeleton-board" }) => (
  <div className="tickets" data-testid={testId} role="status" aria-label="Loading tickets">
    {Array.from({ length: n }).map((_, i) => (
      <div className="skel-card" key={i} style={{ marginBottom: 0 }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
          <Skel w={64} h={15} />
          <Skel w={78} h={15} r={999} />
        </div>
        <Skel w="58%" h={10} />
        <Skel w="88%" h={11} />
        <Skel w="72%" h={11} />
        <Skel w="100%" h={30} r={11} />
      </div>
    ))}
  </div>
);
